/* unplugin-vue-components disabled */import script from "./Avatar.vue?vue&type=script&setup=true&name=Avatar&lang=js"
export * from "./Avatar.vue?vue&type=script&setup=true&name=Avatar&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=dd3f85fa&lang=scss"

const __exports__ = script;

export default __exports__